import { FREE_CAPACITY_COCKPIT } from "~/utils/url/staticUrls";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { MyCompanyMenu } from "~/Header/components/MyCompanyMenu";
import { useSimpleMenuState } from "~/common/components/Menu/Menu";
import { PersonalNavItem } from "~/Header/components/headerMenu/PersonalNavItem";
import { FccAction, trackFccAction } from "~/FreeCapacityPush/api/trackFccAction";

const FCC = () => {
  const { t } = useTranslation();
  const showNew = window.SCHA.config.fccShowNewLabelEnabled;

  return (
    <a
      href={FREE_CAPACITY_COCKPIT}
      data-test-id={"free-capacity-cockpit"}
      onClick={() => trackFccAction(FccAction.IconClick)}
    >
      <PersonalNavItem
        data-test-id={"header-btn-free-capacity-cockpit"}
        icon={IconType.BallBearing}
        name={t("page.fcc.title")}
        badgeContent={showNew ? t("page.abmonitor.badge.new") : undefined}
        badgeVariant={"new"}
      />
    </a>
  );
};

const MyCompany = () => {
  const { t } = useTranslation();
  const [isOpen, handleClick, handleClose, anchorEl] = useSimpleMenuState();
  return (
    <>
      <PersonalNavItem
        name={t("header.link.my.company")}
        icon={IconType.Building}
        data-test-id={"header-btn-my-company"}
        onClick={handleClick}
      />
      <MyCompanyMenu open={isOpen} anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
};

export const NavItems = {
  FCC,
  MyCompany,
};
